module.exports = __webpack_public_path__ + "img/market-potential.698359aa.png";